import React, {ReactElement, Suspense, useEffect, useState} from "react";
import {withRouter, RouteComponentProps} from "react-router-dom";
interface PropsType extends RouteComponentProps<any>{
    weId?: string;
    reactRouterPath: string;
    isAllRoute: boolean;
    ecodePathPrefix: string;
    isChildRoute: boolean;
    childRoutePath: string;
}
const VueRouterMain = (props: PropsType)=>{
    const {reactRouterPath,isAllRoute,ecodePathPrefix,childRoutePath,isChildRoute} = props;
    const [VueContainer, setVueContainer] = useState<ReactElement>();
    let rootPath = `${isChildRoute?childRoutePath:reactRouterPath}`+`${isAllRoute?ecodePathPrefix:''}`+"/v/";
    let isVueRoute = props.location.pathname.indexOf(rootPath)>=0

    useEffect(() => {
        isVueRoute && (window.weappEcodesdk.vueRouter.rootPath = rootPath);
    }, [isVueRoute,rootPath]);
    useEffect(()=>{
        isVueRoute && setVueContainer(
            window.weappEcodesdk.lazyPureVueInReact(()=>new Promise(resolve=>{
                resolve({default:{
                        setup:()=>{
                            return function (){
                                let Vue = window.Vue;
                                let _component_router_view =  Vue.resolveComponent("router-view");
                                return Vue.createElementBlock(Vue.Fragment, null, [
                                    Vue.createVNode(_component_router_view)]
                                );
                            }
                        }
                    }})
            }),
                {
                    plugins:['vue-router'],
                    beforeVueAppMount:(app:any)=>{
                        window.weappEcodesdk.vueRouter.onVuePageAppMount(app);
                    },
                    wrapProps:{
                        className: 'weapp-ecode-vue-router-main',
                        style:{all:"",width:"100%",height:'100%'}
                    }
                }
            )
        )
    },[isVueRoute])
    if(!isVueRoute||!VueContainer) return <></>;
    return <Suspense weId={`${props.weId || ''}_74byal`} fallback={<></>}>
        {/*//@ts-ignore */}
        <VueContainer weId={`${props.weId || ''}_hggsas`}/>
    </Suspense>
}

export default withRouter(VueRouterMain);